import Chart from 'react-apexcharts';

// ----------------------------------------------------------------------

export { default as ChartStyle } from './ChartStyle';
export { default as BaseOptionChart } from './BaseOptionChart';

export default Chart;
